import { render, staticRenderFns } from "./TextAreaExpand.vue?vue&type=template&id=4aa3112a&scoped=true&"
import script from "./TextAreaExpand.vue?vue&type=script&lang=ts&"
export * from "./TextAreaExpand.vue?vue&type=script&lang=ts&"
import style0 from "./TextAreaExpand.vue?vue&type=style&index=0&id=4aa3112a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa3112a",
  null
  
)

export default component.exports